/**
 * Tasks whose dialog should only show the Chat tab (no upload tab),
 * same behavior as parent tasks. Child exception tasks are titled
 * "<task code> - <exception>", so we match by prefix.
 */
export const CHAT_ONLY_TASK_CODES = [
  'Borrower Entity Data Exception',
  'Borrower Data Exception',
  'Underwriting Guideline Exception', // also matches "Underwriting Guideline Exceptions"
];

export const isChatOnlyTask = (taskName?: string): boolean => {
  const name = taskName?.trim().toLowerCase();
  return !!name && CHAT_ONLY_TASK_CODES.some(code => name.startsWith(code.toLowerCase()));
};

/**
 * Whether the task dialog should hide the upload tab and only show the chat.
 */
export const shouldHideTaskUploadTab = (document?: {
  isParentTask?: boolean;
  taskName?: string;
}): boolean =>
  !!document && (!!document.isParentTask || isChatOnlyTask(document.taskName));
